import React, { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import { LayoutDynamicZone } from 'src/modules/layout';
import { ArticleLocalizedEntity, getArticleCategory } from 'src/modules/articles';
import { LayoutBlockHero } from 'src/modules/layout';
import { ProductEntity, ProductsListingOverview } from 'src/modules/products';
import { LayoutCardSize } from 'src/modules/layout';
import LayoutPage from 'src/modules/layout/components/page/LayoutPage';
import { ArticleListingOverview, ArticleLinkPrefix } from 'src/modules/articles';
import styles from './ArticlesDetailsContent.module.scss';
import { Media } from 'react-breakpoints';
import { breakpoints } from 'src/utils/breakpoints';
import { BreadcrumbsProps } from 'src/modules/professionals/downloads/products/components/breadcrumbs/Breadcrumbs';

interface ArticlesDetailsContentProps {
  article: ArticleLocalizedEntity;
  relatedArticles?: ArticleLocalizedEntity[];
  breadcrumbs?: BreadcrumbsProps['links'];
  products?: ProductEntity[];
  // relatedArticlesHeadingTitle?: string;
}

const ArticlesDetailsContent: React.FunctionComponent<ArticlesDetailsContentProps> = ({
  children,
  ...props
}) => {
  const { query } = useRouter();
  const {
    products: productsProps,
    article,
    relatedArticles = [],
    breadcrumbs,
    // relatedArticlesHeadingTitle = 'page/magazine/details/related_articles',
  } = props;
  const { hero, dynamic_content, products, featured_project, reference } = article || {};

  const category = getArticleCategory(props.article);
  const [reMountKey, setReMountKey] = useState('articles-details-content-unmounted');
  useEffect(() => {
    setReMountKey('articles-details-content-mounted');
  }, []);

  const pageProperties = {
    title: hero?.title,
    description: hero?.subline as string,
    canonical: featured_project ? 'professionals/projects/' + query.slug : null,
    breadcrumbs,
    metaImage: hero?.image?.url,
  };
  return (
    <LayoutPage key={reMountKey} {...pageProperties}>
      <article>
        <LayoutBlockHero
          title={hero?.title}
          label={category}
          image={hero?.image}
          subline={hero?.subline}
          cta={hero?.button}
        />

        {dynamic_content && !!dynamic_content.length && (
          <LayoutDynamicZone components={dynamic_content} groupCards={true} />
        )}
      </article>

      {!!children && children}
      <div className={styles.container}>
        {(!!products?.length || !!productsProps?.length) && (
          <section className={styles.block}>
            <ProductsListingOverview
              size={LayoutCardSize.Small}
              headingTitle={
                reference || featured_project
                  ? 'page/professionals/projects/details/related_products'
                  : 'page/magazine/details/related_products'
              }
              headingMore={false}
              oneRow={false}
              relatedOverview={true}
              products={productsProps?.length ? productsProps : products}
            />
          </section>
        )}
        <Media>
          {({ currentBreakpoint }) => {
            return (
              <ArticleListingOverview
                key={`article-listing-${currentBreakpoint}`}
                headingTitle={
                  reference || featured_project
                    ? 'page/professionals/projects/details/similar_projects'
                    : 'page/magazine/details/related_articles'
                }
                articles={relatedArticles}
                link={ArticleLinkPrefix.article}
                relatedOverview={true}
                oneRow={breakpoints[currentBreakpoint] >= breakpoints.md}
                size={LayoutCardSize.Small}
              />
            );
          }}
        </Media>
      </div>
    </LayoutPage>
  );
};

export default ArticlesDetailsContent;
